var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function listEvents(book, afterDate, beforeDate, onError, resourceId, eventType, limit, cursor, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let request = new HttpBooksApiV5Request(`${book.getId()}/events`, config);
        request.addParam('after', afterDate);
        request.addParam('before', beforeDate);
        request.addParam('error', onError);
        request.addParam('resoureId', resourceId);
        request.addParam('type', eventType);
        request.addParam('limit', limit);
        if (cursor != null) {
            request.setHeader('cursor', cursor);
        }
        var response = yield request.fetch();
        return response.data;
    });
}
export function replayBotResponse(book, eventId, agentId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${book.getId()}/events/${eventId}/responses/${agentId}`, config).setMethod('PUT').fetch();
        return response.data;
    });
}
export function deleteBotResponse(book, eventId, agentId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${book.getId()}/events/${eventId}/responses/${agentId}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
export function replayEventsBatch(book, eventList, errorsOnly, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let request = new HttpBooksApiV5Request(`${book.getId()}/events/replay/batch`, config).setMethod('PATCH').setPayload(eventList);
        if (errorsOnly) {
            request.addParam('errorsOnly', errorsOnly);
        }
        yield request.fetch();
    });
}
export function getBacklog(book, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${book.getId()}/events/backlog`, config).setMethod("GET").fetch();
        return response.data;
    });
}
//# sourceMappingURL=event-service.js.map